export default __webpack_public_path__ + "static/media/Version (3) - Order of the Phoenix_16.af93d2fe.jpg";